import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/pt';
import 'dayjs/locale/es';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: [
      'access-denied',
      'common',
      '404',
      'login',
      'store',
      'cabinet-management',
      'datasets',
      'terminal-management',
      'fallback',
      'product-qa',
      'profile',
      'store-project',
      'sensei-user',
      'sessions',
      'planogram',
    ],
    load: 'languageOnly',
    defaultNS: 'common',
    fallbackNS: 'common',
    fallbackLng: 'en',
    backend: {
      loadPath: '/locale/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['querystring', 'cookie', 'navigator'],
      lookupQuerystring: 'lang',
      lookupCookie: 'lang',
      lookupLocalStorage: 'lang',
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
      caches: ['cookie'],
      cookieMinutes: 1440,
    },
    react: {
      useSuspense: true,
      transEmptyNodeValue: '',
    },
  });

dayjs.locale(i18n.language);
i18n.on('languageChanged', (lng) => dayjs.locale(lng));

export default i18n;
